import React from "react";
import { useQuery } from "@tanstack/react-query";
import { InstitutionalHeader } from "@/components/site/InstitutionalHeader";
import { InstitutionalFooter } from "@/components/site/InstitutionalFooter";
import { getSettings, getBrands } from "@/lib/api";

export const SiteLayout = ({ children }) => {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const { data: brands = [] } = useQuery({ queryKey: ["brands"], queryFn: getBrands });
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)" }}>
      <InstitutionalHeader />
      <main id="main">{children}</main>
      <InstitutionalFooter settings={settings} brands={brands} />
    </div>
  );
};
